import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyBottomCarouselWrapper } from './property-bottom-carousel-wrapper';
import { RecommendationsModuleWrapper } from '../similar-hotels/recommendations-module-wrapper';
export const SUVRPropertyBottomCarouselWrapper = () => React.createElement(Experiment, {
  name: "SmaSh_Property_Recs_New_Carousel"
}, React.createElement(ExperimentControl, null, React.createElement(PropertyBottomCarouselWrapper, null)), React.createElement(ExperimentVariant, {
  bucket: 1
}, React.createElement(RecommendationsModuleWrapper, {
  showFeaturedHeader: true
})), React.createElement(ExperimentVariant, {
  bucket: 2
}, React.createElement(RecommendationsModuleWrapper, {
  showFeaturedHeader: false
})));